export const baseUrl = process.env.NODE_ENV === "production" ? `${window.location.origin}/backend` : "http://localhost:85"